import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import DeadlineRule from '../../entities/deadlineRule';
import Deadline from '../../entities/deadline';
import CourtDeadlineRule from '../../entities/courtDeadlineRule';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
import {deleteCourtDeadlineRule, collectCourtDeadlineRuleDeleteImpact} from './courtDeadlineRuleDeps';
export function canDeleteDeadlineRule(): boolean {
return canCascadeDelete();
}
export function collectDeadlineRuleDeleteImpact(deadlineRule: DeadlineRule, context: DeleteImpactContext): void {
const key = 'deadlineRule:' + deadlineRule.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const deadlineDeadlineRuleIdImpact = workingRows<Deadline>('deadline', findAll<Deadline>('deadlines')).filter(deadlineRef => deadlineRef.deadlineRuleId === deadlineRule.id);
deadlineDeadlineRuleIdImpact.forEach(deadlineRef => addDeleteImpact(context, 'deadline:' + deadlineRef.id, 'deadlines'));
const deadlineRuleTriggerRuleIdImpact = workingRows<DeadlineRule>('deadlineRule', findAll<DeadlineRule>('deadlineRules')).filter(deadlineRuleRef => deadlineRuleRef.triggerRuleId === deadlineRule.id);
deadlineRuleTriggerRuleIdImpact.forEach(deadlineRuleRef => addDeleteImpact(context, 'deadlineRule:' + deadlineRuleRef.id, 'deadlineRules'));workingRows<CourtDeadlineRule>('courtDeadlineRule', findAll<CourtDeadlineRule>('courtDeadlineRules')).filter(courtDeadlineRule => courtDeadlineRule.status !== 'D' && courtDeadlineRule.deadlineRuleId === deadlineRule.id).forEach(courtDeadlineRule => {
if (context.visited.has('courtDeadlineRule:' + courtDeadlineRule.id)) return;
addDeleteImpact(context, 'courtDeadlineRule:' + courtDeadlineRule.id, 'courtDeadlineRules');
collectCourtDeadlineRuleDeleteImpact(courtDeadlineRule, context);
});
}
export function deleteImpactDeadlineRule(deadlineRule: DeadlineRule): DeleteImpact {
const context = deleteImpactContext();
collectDeadlineRuleDeleteImpact(deadlineRule, context);
return deleteImpactCounts(context);
}
export function deleteDeadlineRule(deadlineRule: DeadlineRule, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteDeadlineRule()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectDeadlineRuleDeleteImpact(deadlineRule, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || deadlineRule.id};
}
const key = 'deadlineRule:' + deadlineRule.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<CourtDeadlineRule>('courtDeadlineRule', findAll<CourtDeadlineRule>('courtDeadlineRules')).filter(courtDeadlineRule => courtDeadlineRule.status !== 'D' && courtDeadlineRule.deadlineRuleId === deadlineRule.id).forEach(courtDeadlineRule => {deleteCourtDeadlineRule(courtDeadlineRule, mergeId, cascade);});
workingRows<Deadline>('deadline', [...store.getState().deadlines.getMappingFor('deadlineRuleId', deadlineRule.id)]).filter(deadlineTemp => deadlineTemp.deadlineRuleId === deadlineRule.id).forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
if (_deadline.status === 'D') return;
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.deadlineRuleId === deadlineRule.id) {
_deadline.deadlineRuleId = null;

}
_work.set('deadline:' + _deadline.id, _deadline);
dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline), 'deadline:' + _deadline.id);
});
workingRows<DeadlineRule>('deadlineRule', [...store.getState().deadlineRules.getMappingFor('triggerRuleId', deadlineRule.id)]).filter(deadlineRuleTemp => deadlineRuleTemp.triggerRuleId === deadlineRule.id).forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
if (_deadlineRule.status === 'D') return;
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.triggerRuleId === deadlineRule.id) {
_deadlineRule.triggerRuleId = null;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule), 'deadlineRule:' + _deadlineRule.id);
});
const deleted = deadlineRule.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.DeadlineRuleActions.removeDeadlineRuleQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceDeadlineRule(deadlineRule: DeadlineRule, replaceWith: DeadlineRule, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = deadlineRule.id;}
const _work = workingSet();
workingRows<Deadline>('deadline', [...store.getState().deadlines.getMappingFor('deadlineRuleId', deadlineRule.id)]).filter(deadlineTemp => deadlineTemp.deadlineRuleId === deadlineRule.id).forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
if (_deadline.status === 'D') return;
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.deadlineRuleId === deadlineRule.id) {
_deadline.deadlineRuleId = replaceWith.id;

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
workingRows<DeadlineRule>('deadlineRule', [...store.getState().deadlineRules.getMappingFor('triggerRuleId', deadlineRule.id)]).filter(deadlineRuleTemp => deadlineRuleTemp.triggerRuleId === deadlineRule.id).forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
if (_deadlineRule.status === 'D') return;
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.triggerRuleId === deadlineRule.id) {
_deadlineRule.triggerRuleId = replaceWith.id;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
});



workingRows<CourtDeadlineRule>('courtDeadlineRule', findAll<CourtDeadlineRule>('courtDeadlineRules')).filter(courtDeadlineRule => courtDeadlineRule.status !== 'D' && courtDeadlineRule.deadlineRuleId === deadlineRule.id).forEach(courtDeadlineRuleTemp => {
const _courtDeadlineRule = ((_work.get('courtDeadlineRule:' + courtDeadlineRuleTemp.id) ?? courtDeadlineRuleTemp) as CourtDeadlineRule).clone();
if (_courtDeadlineRule.status === 'D') return;
_courtDeadlineRule.deadlineRuleId = replaceWith.id;
_courtDeadlineRule.status = 'U';
_courtDeadlineRule.addedOn = newHRTimestamp();
_courtDeadlineRule.addedBy = getCurrentUserId();
_courtDeadlineRule.importSource = targetImportSource;
_courtDeadlineRule.importId = mergeId;
_work.set('courtDeadlineRule:' + _courtDeadlineRule.id, _courtDeadlineRule);
store.dispatch(Actions.CourtDeadlineRuleActions.saveCourtDeadlineRuleQueue(_courtDeadlineRule));
});
return deadlineRule;
}
